



























import { defineComponent } from '@vue/composition-api';

import DisplaySessionItems from '@/components/DisplaySessionItems.vue';

export default defineComponent({
  name: 'SelectSessionItem',

  components: {
    DisplaySessionItems,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    }
  },

  setup(props, { emit }) {
    /**
     * Handler for select event
     * @param {number} id
     * */
    function selectEventHandler(id: number) {
      emit('select', id, props.type);
    }

    /**
     * Check is selected
     * @param {number} id
     * @return {boolean}
     * */
    function isSelected(id: number) {
      return !!props.selected.find((item: any) => item.id === id)
    }

    return {
      selectEventHandler,
      isSelected,
    };
  }
});
